import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import homePlugin from '@backstage/plugin-home/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import qaAutomatedTestsPlugin from '@internal/plugin-qa-automated-tests/alpha';
import galileoS3ExplorerPlugin from '@internal/plugin-galileo-s3-explorer/alpha';
import galileoIacPlugin from '@internal/plugin-galileo-iac/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import techdocsAddonsPlugin from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import mermaidAddonPlugin from 'backstage-plugin-techdocs-addon-mermaid/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { useApi } from '@backstage/core-plugin-api';
import { configApiRef } from '@backstage/core-plugin-api';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      return props => {
        const configApi = useApi(configApiRef);
        const environment = configApi.getString('auth.environment');

        // Development: Show guest and GitHub providers
        if (environment === 'development') {
          return (
            <SignInPage
              {...props}
              providers={[
                'guest',
                {
                  id: 'github-auth-provider',
                  title: 'GitHub',
                  message: 'Sign in using GitHub',
                  apiRef: githubAuthApiRef,
                },
              ]}
            />
          );
        }

        // Production: Only GitHub OAuth
        return (
          <SignInPage
            {...props}
            provider={{
              id: 'github-auth-provider',
              title: 'GitHub',
              message: 'Sign in using GitHub',
              apiRef: githubAuthApiRef,
            }}
          />
        );
      };
    },
  },
});

const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});

export default createApp({
  features: [
    catalogPlugin,
    apiDocsPlugin,
    scaffolderPlugin,
    techdocsPlugin,
    searchPlugin,
    homePlugin,
    orgPlugin,
    userSettingsPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    kubernetesPlugin,
    notificationsPlugin,
    signalsPlugin,
    galileoS3ExplorerPlugin,
    galileoIacPlugin,
    qaAutomatedTestsPlugin,
    githubActionsPlugin,
    techdocsAddonsPlugin,
    mermaidAddonPlugin,
    navModule,
    homeModule,
    signInPageModule,
  ],
});
